import React from "react";
import { withRouter } from "react-router-dom";

class BaiduTrack extends React.Component<any> {
    componentDidMount() {
        const key = "57b28274c89c743ccfe7ecbe93767862";
        const hm = document.createElement("script");
        hm.src = `https://hm.baidu.com/hm.js?${key}`;
        const s = document.getElementsByTagName("script")[0];
        // @ts-ignore
        s.parentNode.insertBefore(hm, s);
    }

    componentDidUpdate(prevProps: any) {
        // @ts-ignore
        const _hmt = window._hmt;
        _hmt && _hmt.push(["_trackPageview", this.props.location.pathname]);
    }

    render() {
        return null;
    }
}

export default withRouter(BaiduTrack);
